import { render, staticRenderFns } from "./iframeItem.vue?vue&type=template&id=9451417c&scoped=true&"
import script from "./iframeItem.vue?vue&type=script&lang=js&"
export * from "./iframeItem.vue?vue&type=script&lang=js&"
import style0 from "./iframeItem.vue?vue&type=style&index=0&id=9451417c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9451417c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9451417c')) {
      api.createRecord('9451417c', component.options)
    } else {
      api.reload('9451417c', component.options)
    }
    module.hot.accept("./iframeItem.vue?vue&type=template&id=9451417c&scoped=true&", function () {
      api.rerender('9451417c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/iframe/iframeItem.vue"
export default component.exports